'use strict';

class Bullet {
  constructor() {
    this.active = false;
    this.x = 0;
    this.y = 0;
    this.vx = 0;
    this.vy = 0;
    this.heading = 0;
    this.speed = 0;
    this.turnRate = 0;
    this.homing = false;
    this.radius = 10;
    this.color = '#ff496c';
  }

  reset(options) {
    this.active = true;
    this.x = options.x;
    this.y = options.y;
    this.vx = Number(options.vx) || 0;
    this.vy = Number(options.vy) || 0;
    this.speed = Number(options.speed) || Math.sqrt(this.vx * this.vx + this.vy * this.vy);
    this.heading = Number.isFinite(options.heading)
      ? options.heading
      : Math.atan2(this.vy, this.vx);
    this.turnRate = Math.max(0, Number(options.turnRate) || 0);
    this.homing = Boolean(options.homing);
    this.vx = Math.cos(this.heading) * this.speed;
    this.vy = Math.sin(this.heading) * this.speed;
    this.radius = options.radius || 10;
    this.color = options.color || '#ff496c';
    return this;
  }

  update(dt, bounds, target) {
    if (!this.active) return;
    if (
      this.homing && target &&
      Number.isFinite(target.x) && Number.isFinite(target.y) &&
      this.turnRate > 0
    ) {
      const desiredHeading = Math.atan2(target.y - this.y, target.x - this.x);
      const difference = Math.atan2(
        Math.sin(desiredHeading - this.heading),
        Math.cos(desiredHeading - this.heading)
      );
      const maxTurn = this.turnRate * dt;
      const turn = Math.max(-maxTurn, Math.min(maxTurn, difference));
      this.heading += turn;
      this.vx = Math.cos(this.heading) * this.speed;
      this.vy = Math.sin(this.heading) * this.speed;
    }
    this.x += this.vx * dt;
    this.y += this.vy * dt;
    const margin = this.radius + 60;
    if (
      this.x < bounds.left - margin || this.x > bounds.right + margin ||
      this.y < bounds.top - margin || this.y > bounds.bottom + margin
    ) {
      this.active = false;
    }
  }

  draw(ctx) {
    if (!this.active) return;
    ctx.save();
    ctx.strokeStyle = this.color;
    ctx.globalAlpha = 0.42;
    ctx.lineWidth = Math.max(3, this.radius * 0.45);
    ctx.beginPath();
    ctx.moveTo(this.x, this.y);
    ctx.lineTo(
      this.x - Math.cos(this.heading) * this.radius * 2.3,
      this.y - Math.sin(this.heading) * this.radius * 2.3
    );
    ctx.stroke();
    ctx.globalAlpha = 1;
    ctx.shadowColor = this.color;
    ctx.shadowBlur = 16;
    const gradient = ctx.createRadialGradient(
      this.x - this.radius * 0.3,
      this.y - this.radius * 0.3,
      1,
      this.x,
      this.y,
      this.radius
    );
    gradient.addColorStop(0, '#ffffff');
    gradient.addColorStop(0.35, this.color);
    gradient.addColorStop(1, 'rgba(255, 73, 108, 0.4)');
    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  getHitCircle() {
    return { x: this.x, y: this.y, radius: this.radius * 0.82 };
  }
}

module.exports = Bullet;
